import ztComponent from './ztChip.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
